import { render } from "./upload-PJ.vue?vue&type=template&id=3c9f9cad&scoped=true&lang=true"
import script from "./upload-PJ.vue?vue&type=script&lang=js"
export * from "./upload-PJ.vue?vue&type=script&lang=js"

import "./upload-PJ.vue?vue&type=style&index=0&id=3c9f9cad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9f9cad"]])

export default __exports__